import styled from "@emotion/styled"
import Link from "next/link"
import { ReadMoreIcon } from "ui/icons"

import colors from "theme/colors"
import { TitleWithLine } from "ui"
import { extractProperty } from "utils"
import { getNonUmbracoURL } from "utils/utils"

const StyledQuoteWrapper = styled.div`
  padding: 32px 20px 32px 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 50px 146px 50px 146px;
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 90px 220px 90px 220px;
  }
`

const StyledRichWrapper = styled.div`
  p {
    font-size: 20px;
    line-height: 28px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 18px;
      line-height: 25px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      font-size: 28px;
      line-height: 40px;
    }
  }
`
const StyledCTA = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.theme.colors.blue};
  text-decoration: none;
  margin-top: 12px;
  font-size: 16px;
  line-height: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 12px;
    line-height: 18px;
    margin-top: 12px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 18px;
    line-height: 25.2px;
    margin-top: 20px;
  }
`

function PazomatQuote({ data }: any) {
  const conetntTitle = extractProperty(data, "conetntTitle")
  const subTitle = extractProperty(data, "subTitle")
  const innerText = extractProperty(data, "innerText")
  const link = extractProperty(data, "link")

  const title = conetntTitle || subTitle
  return (
    <StyledQuoteWrapper>
      {title &&
        <TitleWithLine
          title={title}
          titleColor={colors.black}
          component={"h1"}
        />
      }
      {innerText &&
        <StyledRichWrapper dangerouslySetInnerHTML={{ __html: innerText }} />
      }
      {link && link[0]?.url &&
        <StyledCTA href={getNonUmbracoURL(link[0]?.url)}>
          {link[0]?.name}
          <ReadMoreIcon />
        </StyledCTA>
      }
    </StyledQuoteWrapper>
  )
}

export default PazomatQuote
